import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'

export const HealthCheckTable = ({ data, context }) => {
  const [openSubsections, setOpenSubsections] = useState({});

  function toggleSubsSection(id) {
    setOpenSubsections(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const [syncStatus, setSyncStatus] = useState({})
  function updateSyncStatus(key, state) {
    ['inprogress', 'notattempted', 'success', 'failure'].includes(state) || (() => { throw new Error('Invalid value') })()
    setSyncStatus(prev => ({ ...prev, [key]: state }))
  }
  const syncIconClasses = {
    'inprogress': 'fa-solid fa-fw mr-4 text-info fa-spinner',
    'notattempted': 'fa-solid fa-fw mr-4 text-primary fa-circle-minus',
    undefined: 'fa-solid fa-fw mr-4 text-primary fa-circle-minus',
    'success': 'fa-solid fa-fw mr-4 text-success fa-check-circle',
    'failure': 'fa-solid fa-fw mr-4 text-error fa-circle-x',
  }
  const spinStyle = {
    animation: 'spin 1s linear infinite'
  };



  async function requestGradeSync(items) {
    try {
      let syncResponse = await client.post(
        '/account/admin_lti13.syncGrades',
        {
          context: context,
          resource_links: items
        },
      )
      return syncResponse.data
    } catch (err) {
      toast.error(`${err.response.statusText} ${err.response.data.error}`)
      throw err
    }
  }

  async function requestUserSync(resourceLinkId, userEmail) {
    updateSyncStatus(`${resourceLinkId}-${userEmail}`, 'inprogress')
    const requestData = {}
    requestData[resourceLinkId] = [userEmail]
    try {
      const data = await requestGradeSync(requestData)
      updateSyncStatus(`${resourceLinkId}-${userEmail}`, data.results[`${resourceLinkId}-${userEmail}`].result)
    } catch (err) {
      updateSyncStatus(`${resourceLinkId}-${userEmail}`, 'failure')
    }
  }

  async function requestResourceLinkSync(resourceLinkData) {
    updateSyncStatus(resourceLinkData.resource_link_id, 'inprogress')
    const requestData = {}
    requestData[resourceLinkData.resource_link_id] = resourceLinkData.matches.map(match => {
      updateSyncStatus(`${resourceLinkData.resource_link_id}-${match.user.email}`, 'inprogress')
      return match.user.email
    })
    try {
      const data = await requestGradeSync(requestData)
      Object.entries(data.results).map((data => {
        updateSyncStatus(data[0], data[1].result)
      }))
    } catch (err) {
      resourceLinkData.matches.map(match => {
        updateSyncStatus(`${resourceLinkData.resource_link_id}-${match.user.email}`, 'failure')
      })

    }
  }

  return (
    <React.Fragment>
      <h1 className="me-page-title">Health Check Results</h1>
      {data.missing_items && data.missing_items.length > 0 && (
        <div className="card-myed">
          <h3>Missing Activities</h3>
          <p>The following activities are missing from the LMS when we expected them to be present.</p>
          <div className="table-responsive">
          <table className="table table-danger">
            <thead>
              <tr>
                <th scope="col">Activity Title</th>
                <th scope="col">Course Number</th>
                <th scope="col">Resource Link GUID</th>
                <th scope="col">Activity ID</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.missing_items.map((link, index) => (
                <tr key={link.guid || index} className="danger">
                  <td>
                    <i className="fa-solid fa-fw mr-4 color_red icon_color_red fa-exclamation-triangle" /> {link.activity_name}
                  </td>
                  <td>{link.coursenum}</td>
                  <td>{link.resource_link_guid}</td>
                  <td>{link.activity_id}</td>
                  <td>
                    <button className="btn btn-myed btn-default btn-default-myed btn-sm-myed">
                      Fix Link
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}

      {data.unknown_items && data.unknown_items.length > 0 && (
        <div className="card-myed">
          <h3 className="mt-4">Unknown Activities</h3>
          <p>The following activities are unknown to us. They are found in the LMS but not found in our system.</p>
          <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Label</th>
                <th scope="col">ID</th>
                <th scope="col">Resource ID</th>
                <th scope="col">Resource Link ID</th>
              </tr>
            </thead>
            <tbody>
              {data.unknown_items.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{item.label}</td>
                  <td>{item.id}</td>
                  <td>{item.resourceId}</td>
                  <td>{item.resourceLinkId}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}

      {data.valid_items && data.valid_items.length > 0 && (
        <div className="card-myed">
          <h3 className="mt-4">Valid Activities</h3>
          <p>The following activities seem to be correctly configured in the LMS.</p>
          <div className="table-responsive">
          <table className="table table-danger">
            <thead>
              <tr>
                <th scope="col">Activity Title</th>
                <th scope="col">Course Number</th>
                <th scope="col">Resource Link GUID</th>
                <th scope="col">Activity ID</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.valid_items.map((link, index) => (
                <tr key={link.guid || index} className="success">
                  <td>
                    <i className="fa-solid fa-fw mr-4 text-success fa-check-circle" /> {link.activity_name}
                  </td>
                  <td>{link.coursenum}</td>
                  <td>{link.resource_link_guid}</td>
                  <td>{link.activity_id}</td>
                  <td />
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}

      {data.unsynced_grades && data.unsynced_grades.length > 0 && (
        <div className="card-myed">
          <style>{` @keyframes spin { to {transform: rotate(360deg); } `} </style>
          <h3 className="mt-4">Unsynced Grades</h3>
          <p>The following grades show up in MyEducator but not in the LMS.</p>
          <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Email</th>
                <th scope="col">MyEd Score</th>
                <th scope="col">LMS Score</th>
                <th scope="col"></th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {data.unsynced_grades.map((resource, outer_index) => {
                const subRowStyle = { 'fontSize': '1rem', }
                const resourceLinkStatusKey = resource.resource_link_id
                const resourceLinkSyncStatus = syncStatus[resourceLinkStatusKey]
                return (
                  <React.Fragment key={outer_index}>
                    <tr key={outer_index} className='info' style={subRowStyle}>
                      <td colSpan={3} onClick={() => { toggleSubsSection(resource.resource_link_id) }}>
                        <div className='d-flex flex-row align-content-center '>
                          <div className='m-2'>
                            {openSubsections[resource.resource_link_id] ? '▼' : '▶'}
                          </div>
                          <div>
                            <div>
                              Resource Link: {resource.resource_guid}
                            </div>
                            <div>
                              Activity Title: {resource.activity_title}
                            </div>
                            <div>
                              Unsynced Grade Count: {resource.matches.length}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button
                          disabled={resourceLinkSyncStatus === 'inprogress' ? true : false}
                          onClick={async () => await requestResourceLinkSync(resource)}
                          className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
                        >
                          {resourceLinkSyncStatus === 'inprogress' ? 'Syncing...' : resourceLinkSyncStatus === 'success' ? 'Synced' : 'Sync Resource Link'}
                        </button>
                      </td>
                      <td>
                        <i
                          className={syncIconClasses[resourceLinkSyncStatus]}
                          style={resourceLinkSyncStatus === 'inprogress' ? spinStyle : {}}
                        />
                      </td>
                    </tr>
                    {
                      openSubsections[resource.resource_link_id] && resource.matches.map((data, index) => {
                        const statusKey = `${resource.resource_link_id}-${data.user.email}`
                        const userSyncStatus = syncStatus[statusKey]
                        return (
                          <tr key={index} className="active">
                            <td>{data.user.email}</td>
                            <td>{data.myed_score}</td>
                            <td>{data.lms_score}</td>
                            <td>
                              <button
                                disabled={['inprogress', 'success'].includes(userSyncStatus) ? true : false}
                                onClick={async () => await requestUserSync(resource.resource_link_id, data.user.email)}
                                className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
                              >
                                {userSyncStatus === 'inprogress' ? 'Syncing...' : userSyncStatus === 'success' ? 'Synced' : 'Sync User'}
                              </button>
                            </td>
                            <td>
                              <i
                                className={syncIconClasses[userSyncStatus]}
                                style={userSyncStatus === 'inprogress' ? spinStyle : {}}
                              />
                            </td>
                          </tr>
                        )
                      })
                    }
                  </React.Fragment>
                )
              })}
            </tbody>
          </table>
          </div>
        </div>
      )
      }
    </React.Fragment >
  )
}

HealthCheckTable.propTypes = {
  data: PropTypes.object.isRequired
}
